
































































































































import Vue, { VueConstructor } from 'vue';
import { AxiosResponse, AxiosError } from 'axios';
import { EditInformation, SupportProperties, SupportType } from '../../../models';
import services from '../../../services';
import mapper from '../mappers';
import FinishedPageDialog from '@/common/components/FinishedPageDialog.vue';
import { PageTitle } from '@/common/components';
import { RulesOperatorHelper } from '../../../common/utils/RulesOperatorHelper';
import { ToastMessage } from '@/plugins/toast/models/message';
import { ErrorStatesOptions } from '@/models/errorEntities';
import lang from '../../../common/lang/de';

const { UserService } = services;

export default (Vue as VueConstructor<Vue & {
  formValid: boolean;
  $refs: {
    finishedPageDialog: InstanceType<typeof FinishedPageDialog>,
    form: HTMLFormElement,
  },
}>).extend({
  name: 'EditCustomer',
  components: {
    FinishedPageDialog,
    PageTitle,
  },
  data() {
    return {
      textInfo: '' as string,
      textInfoHeader: '' as string,
      textInfoSubHeader: '' as string,
      form: mapper.createUserDataVm(),
      originalData: mapper.createUserDataVm(),
      subject: '' as string,
      contactPerson: '' as string,
      description: '' as string,
      prioCallOption: false as boolean,
      errors: [] as string[],
      formValid: false as boolean,
      rules: {
        form: () => this.formValid,
        maxLength: (value) => (value.trim().length <= 40) || RulesOperatorHelper.maxLength(40),
        additionalTextMaxLength: (value) => (value.trim().length <= 255) || RulesOperatorHelper.maxLength(255),
        minLength: (value) => (value && value.trim().length >= 4) || RulesOperatorHelper.minLength(4),
        telephoneMaxLength: (value) => (value.trim().length <= 16) || RulesOperatorHelper.maxLength(16),
        email: (value) => (value && RulesOperatorHelper.validateEmail(value) || RulesOperatorHelper.errorValidateEmail(value)),
        webSite: (value) => (RulesOperatorHelper.validateWebSite(value) || RulesOperatorHelper.errorValidateWebSite(value)),
        countryMaxLength: (value) => (value.trim().length <= 25) || RulesOperatorHelper.maxLength(25),
        zip: (value) => (value.trim().length <= 5) || RulesOperatorHelper.maxLength(5),
        onlyNumbers: (value) => (value && RulesOperatorHelper.onlyNumbers(value) || RulesOperatorHelper.errorOnlyNumbers(value)),
        required: (value) => (!!value && (value.trim() !== '')) || lang.formRules.required,
      } as any,
    };
  },
  created() {
    this.getEditInformation();
  },
  methods: {
    getEditInformation() {
      this.$loader.show();
      UserService.getEditInformation(this.$store.getters['user/getDebtorNumber']).then((result: AxiosResponse<EditInformation>) => {
        this.form = mapper.mapEditDtoToUserDataVm(result.data);
        this.originalData = mapper.mapEditDtoToUserDataVm(result.data);
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      }).catch((err: AxiosError) => {
        if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.NotAuthorized);
          this.$router.push({ name: 'Index' });
        } else {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.UnexpectedError);
        }
      });
    },
    editUser(event) {
      this.checkForm(event);
      if (this.formValid) {
        let text = 'Der Kunde wünscht die Änderung seiner Adress-Daten. Nachfolgend sind nur die vom Kunden geänderten Daten gelistet:\r\n';
        text += this.originalData.nameOrCompany !== this.form.nameOrCompany ? `Name:         ${this.form.nameOrCompany}\r\n` : '';
        text += this.originalData.additionalText !== this.form.additionalText ? `Zusatztext:         ${this.form.additionalText}\r\n` : '';
        text += this.originalData.street !== this.form.street ? `Strasse:         ${this.form.street}\r\n` : '';
        text += this.originalData.zip !== this.form.zip || this.originalData.city !== this.form.city ? `PLZ, Ort:     ${this.form.country.length > 0 ? `${this.form.country}` : ''} ${this.form.zip} ${this.form.city}\r\n` : '';
        text += this.originalData.phoneBusiness !== this.form.phoneBusiness ? `Tel.(gesch.):         ${this.form.phoneBusiness}\r\n` : '';
        text += this.originalData.phoneAlternative !== this.form.phoneAlternative ? `Tel.(alter.):         ${this.form.phoneAlternative}\r\n` : '';
        text += this.originalData.fax !== this.form.fax ? `Fax:         ${this.form.fax}\r\n` : '';
        text += this.originalData.email !== this.form.email ? `eMail:         ${this.form.email}\r\n` : '';
        text += this.originalData.website !== this.form.website ? `Web-Site:         ${this.form.website}\r\n` : '';
        // text += '"-------------------------------------------------------------------------------------------------------------------" + "\r\n\r\n";';

        const supportParams = {
          osaId: this.$store.getters['user/getOsaId'],
          debtorNumber: this.$store.getters['user/getDebtorNumber'],
          appId: Number(this.$store.getters['user/getAppId']),
          subject: 'OSA: Änderung der Adress-Daten gewünscht',
          message: text,
          supportType: SupportType.Standard,
        } as SupportProperties;

        UserService.addRequest(supportParams).then((result: AxiosResponse<boolean>) => {
          const header = 'Änderungen übertragen';
          const body = 'Wir haben Ihre geänderten Adress- und Kontakt-Daten erhalten. '
            + 'Nach Überprüfung werden diese Daten in unser Adressen-Management-System übernommen. '
            + 'Die geänderten Daten sind erst ab Freigabe im Osa-System sichtbar. In der Regel werden die '
            + 'Änderung innerhalb von 1-3 Werktagen durchgeführt.';
          const preFooter = 'Mit freundlichen Grüßen,';
          const footer = 'Ihre Werbas KSR GmbH';
          this.$refs.finishedPageDialog.pop(header, body, preFooter, footer).then(r => {
            if (r === true) {
              this.$router.push({ name: 'Welcome' });
            }
          });
        }).catch((err: AxiosError) => {
          if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.NotAuthorized);
            this.$router.push({ name: 'Index' });
          } else {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.UnexpectedError);
          }
        });
      }
    },
    goTo() {
      this.$router.push({ name: 'Welcome' });
    },
    checkForm(event: any) {
      this.errors = [];

      if (!this.$refs.form.validate()) {
        this.formValid = false;
      }
      if (!this.form.nameOrCompany) {
        this.errors.push('Der Name bzw. die Firma muss angegeben werden.');
        this.formValid = false;
      }
      if (!this.form.phoneBusiness) {
        this.errors.push('Geben Sie bitte Ihre Telefon-Nummber an.');
        this.formValid = false;
      }
      if (!this.form.email) {
        this.errors.push('Geben Sie bitte eine Email-Adresse an.');
        this.formValid = false;
      }
      event.preventDefault();
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
  },
});
